export default "__VITE_ASSET__BrzhzKRY__"